module.exports = __webpack_public_path__ + "static/img/homeTop.a4a0d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeTop.png
// module id = hX37
// module chunks = 4